import { EMAIL_REGEX } from '@asgard/utils';
import { z } from 'zod';
import { CompaniesFormFields } from './Form.types';
import { FormSelectOption } from 'components/form/FormSelect/FormSelect.types';
import { howDoYouKnowUsValues } from '@asgard/api-common';
import { i18n } from 'next-i18next';

const I18N_PREFIX = 'companies2:companies';

export const DEFAULT_TYPE_OPTION: FormSelectOption = {
  label: 'SELECT_ONE',
  value: ''
};

export const CompaniesFormFieldsSchema = z.object({
  name: z.string(),
  email: z.string(),
  description: z.string(),
  company: z.string(),
  howDoYouKnowUs: z.enum(howDoYouKnowUsValues),
  contactPhone: z.string().optional(),
  terms: z.boolean().optional(),
  isSubscribeToNewsletter: z.boolean()
});

export const CompaniesFormFieldsValidationSchema =
  CompaniesFormFieldsSchema.partial()
    // Name required
    .refine((schema) => !!schema.name, {
      path: ['name'],
      message: `${I18N_PREFIX}.form.required-name`
    })

    // Email required
    .refine((schema) => !!schema.email, {
      path: ['email'],
      message: `${I18N_PREFIX}.form.required-email`
    })

    // Email format
    .refine((schema) => schema.email?.match(EMAIL_REGEX), {
      path: ['email'],
      message: `${I18N_PREFIX}.form.invalid-email`
    })

    // Description required
    .refine((schema) => !!schema.description, {
      path: ['description'],
      message: `${I18N_PREFIX}.form.required-description`
    })

    // How do you know us required
    .refine((schema) => !!schema.howDoYouKnowUs, {
      path: ['howDoYouKnowUs'],
      message: i18n?.t(`${I18N_PREFIX}.form.required-how-do-you-know-us`, {
        ns: I18N_PREFIX
      })
    })

    // company required
    .refine((schema) => !!schema.company, {
      path: ['company'],
      message: `${I18N_PREFIX}.form.required-company`
    });

export const FORM_FIELDS_DEFAULT_VALUES: Partial<CompaniesFormFields> = {
  name: '',
  email: '',
  description: '',
  company: '',
  contactPhone: '',
  howDoYouKnowUs: undefined,
  isSubscribeToNewsletter: false
};
